import { render, staticRenderFns } from "./CalendarEventShowModal.vue?vue&type=template&id=2a5d03ca&"
import script from "./CalendarEventShowModal.vue?vue&type=script&lang=js&"
export * from "./CalendarEventShowModal.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventShowModal.vue?vue&type=style&index=0&id=2a5d03ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports